import React, { useState } from 'react';

import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import makeStyles from '@mui/styles/makeStyles';

import { Title, BaseLayout } from '../../';

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(3),
		display: 'flex',
		overflow: 'auto',
		flexDirection: 'column'
	},
	fixedHeight: {
		height: 120
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	}
}));

export default function NotFound() {
	const classes = useStyles();
	return (
		<BaseLayout>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Paper className={classes.paper}>
						<Title>Oops! That page can't be found, please try a different one.</Title>
					</Paper>
				</Grid>
			</Grid>
		</BaseLayout>
	);
}
